import { Promise as bluebird } from 'bluebird';
import { storefrontClient } from "@merchstores/frontend/App";
import { getProductByHandle } from "@merchstores/frontend/queries/storefront-graphql";
import { ICartItem, ICartProduct, IProductVariant } from '@merchstores/frontend/reduxTypes';

export class MissingProductsError extends Error
{
  missingProductHandles: Array<string>;
  availableProducts: Array<ICartProduct>;

  constructor(
    msg: string, 
    missingProductHandles: Array<string>, 
    availableProducts: Array<ICartProduct>
  ) 
  {
    super(msg);
    this.missingProductHandles = missingProductHandles;
    this.availableProducts = availableProducts;
  }

  getMissingHandles(): Array<string>
  {
    return this.missingProductHandles;
  }

  getAvailableProducts(): Array<ICartProduct>
  {
    return this.availableProducts;
  }
}


export function mapProductsByHandle(products: Array<ICartProduct>) : Map<string, ICartProduct>
{
  const productsByHandle = new Map();

  products.forEach(product => {
    productsByHandle.set(product.handle, product);
  });

  return productsByHandle;
}

export function mapProductVariantsById(product: ICartProduct) : Map<string, IProductVariant>  
{
  const productVariantsById = new Map();

  const parentPrice = product.price;
  const parentImages = product.images;

  (product as any).variants.edges.forEach((productVariantEdge: { node: any }) => {
    const productVariant = productVariantEdge.node;

    productVariant.price = productVariant.price || parentPrice;
    productVariant.images = productVariant.images || parentImages;

    productVariantsById.set(productVariant.id, productVariant);
  });

  return productVariantsById;
}

export async function fetchProductsForItems(cartItems: Array<ICartItem>) : Promise<Array<ICartProduct>>
{
  const productHandles = cartItems.map(item => item.handle);
  const missingProductHandles : Array<string> = [];

  const uniqueProductHandles = Array.from(
    new Set(productHandles).values()
  );

  let products = await bluebird.map(uniqueProductHandles, async productHandle => {
    const productQueryResponse = await storefrontClient.send(getProductByHandle(productHandle));
    const productQueryData = productQueryResponse.data;

    let product = null;

    if (!productQueryData.productByHandle) {
      missingProductHandles.push(productHandle as string);
      return product;
    }

    product = { ...productQueryData.productByHandle };

    product.images = product.images.edges.map((imageEdge: { node: any; }) => {
      return imageEdge.node;
    })

    return product;
  }, { concurrency: 3 });

  products = products.filter(Boolean);

  if (missingProductHandles.length)
  {
    throw new MissingProductsError(
      `Missing products ${JSON.stringify(missingProductHandles)}`,
      missingProductHandles,
      products
    );
  }

  return products;
}